<template>
  <section class="section pt-1 bg-white">
    <div class="container">
      <h1 class="mb-4">{{ $t("help.platform.announcement.text") }}</h1>

      <b-card no-body class="custom-accordion shadow-none mb-3">
        <b-card-body>
          <p class="mb-3">
            {{ $t("help.platform.announcement.line-1") }}
          </p>
        </b-card-body>
      </b-card>

      <div role="tablist">
        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1' ? 'founded' : ''" v-b-toggle.col1>
              <div>{{ $t("help.platform.announcement.organization.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col1" :visible="col == 'col1'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.announcement.organization.line-1") }}
              </p>

              <img src="@/assets/images/help/organization-announcement.png" class="image" />
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col2' ? 'founded' : ''" v-b-toggle.col2>
              <div>
                {{ $t("help.platform.announcement.account.text") }}
              </div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col2" :visible="col == 'col2'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.announcement.account.line-1") }}
              </p>

              <!-- <h5 class="mt-5">{{$t("help.organization.create.sample-screen")}}</h5> -->
              <img src="@/assets/images/help/announcement.png" class="image" />
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      col: "col1",
    };
  },
  mounted() {
    setTimeout(() => {
      const { col } = this.$route.query;
      this.col = col;
      window.scrollTo({ top: 700, behavior: "smooth" });
    }, 500);
  },
};
</script>

<style scoped>
.founded {
  background: yellow !important;
}
.image {
  display: block;
  max-width: 100%;
}
</style>
